import { css } from 'lit';
import { hostReset, floatingPanel, placementOriginsExtended } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  floatingPanel('.panel', {
    scaleFrom:       'scale(0.93)',
    scaleTo:         'scale(1)',
    durationVar:     '--uwc-tooltip-duration',
    durationDefault: '120ms',
    easing:          'ease',
  }),
  placementOriginsExtended,
  css`
    :host { display: contents; }
    slot[name="trigger"] { display: contents; }

    /* ── Panel (visual) ─────────────────────────────────────────────────────── */
    .panel {
      overflow: visible;
      --bg: var(--uwc-tooltip-bg, #1c1c22);
      background:    var(--bg);
      border-radius: var(--uwc-tooltip-radius,    7px);
      border:        none;
      box-shadow:    var(--uwc-tooltip-shadow,    ${t.shadowLg});
      z-index:       var(--uwc-tooltip-z,         ${t.zTooltip});
      max-width:     var(--uwc-tooltip-max-width, 280px);
    }

    /* ── Text content ───────────────────────────────────────────────────────── */
    .text {
      padding: 6px 10px;
      font-size:   var(--uwc-tooltip-font-size, ${t.fontSizeXs});
      line-height: 1.5;
      color:       var(--uwc-tooltip-color, rgba(255,255,255,0.88));
      white-space: nowrap;
    }

    /* ── Arrow ──────────────────────────────────────────────────────────────── */
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background: var(--bg);
      transform: rotate(45deg);
      border-radius: ${t.radiusXs};
      z-index: -1;
    }
  `,
];
